





























































import Vue from 'vue';
import * as attributoApi from '../services/attributo-api';
import { AttributoList, AttributoListViewModel } from '../types';
import tipoAttributoSelector from '@/components/selectors/TipoAttributoSelector.vue';

export default Vue.extend({
    components: { tipoAttributoSelector },
    data(): AttributoListViewModel {
        return {
            columns: [
                {
                    text: this.$i18n.t('labels.valore'),
                    value: 'displayName',
                },
                {
                    text: this.$i18n.t('labels.descrizione'),
                    value: 'descrizione',
                },
            ],
            dataItems: [],
            search: '',
            selectedItems: [],
            tipo: '',
        };
    },
    computed: {
        canDelete(): boolean {
            return this.selectedItems.length > 0;
        },
    },
    methods: {
        async loadData(): Promise<void> {
            this.dataItems = await attributoApi.getByTipo(this.tipo, null);
        },
        showDetail(item: AttributoList) {
            this.$router.push({
                name: 'AttributoDetail',
                params: { id: item.id.toString() },
            });
        },
        async deleteItems(): Promise<void> {
            if (
                await this.$confirm(
                    this.$t('dialog.default-question').toString(),
                    {
                        title: this.$t('dialog.delete-title').toString(),
                        color: 'secondary',
                        icon: 'mdi-delete',
                    }
                )
            ) {
                await attributoApi.remove(
                    this.selectedItems.map((p) => {
                        return {
                            id: p.id,
                            version: p.version,
                        };
                    })
                );
                await this.loadData();
            }
        },
    },

    async mounted() {
        if (this.$route.params.tipo) this.tipo = this.$route.params.tipo;
    },
    watch: {
        $route: {
            handler: async function () {
                await this.loadData();
            },
            deep: true,
        },
        tipo: {
            handler: async function () {
                await this.loadData();
            },
        },
    },
});
